<greco-tiles-grid
  [communities]="(communities$ | async) || []"
  [tileGroup]="tileGroup || undefined"
  (refresh)="refresh()"
></greco-tiles-grid>
